


































import Vue from 'vue'
import Logo from '@/components/atoms/Logo/Logo.vue'
import XSocialButton from '@/components/atoms/Button/XSocialButton.vue'

export default Vue.extend({
  name: 'XAppFooter',
  components: { Logo, XSocialButton },
  data() {
    return {
      linkItems: [
        {
          href: 'https://tavenal.com/',
          title: this.$tc('footer.brand'),
        },
        {
          href: this.$router.resolve({ name: 'TermsStoreSales' }).href,
          title: this.$tc('common.termsStoreSalesOfService'),
        },
        {
          href: this.$router.resolve({ name: 'TermsAgentSales' }).href,
          title: this.$tc('common.termsAgentSalesOfService'),
        },
        {
          href: this.$router.resolve({ name: 'TermsAgentSalesTelAndFax' }).href,
          title: this.$tc('common.termsAgentSalesTelAndFaxOfService'),
        },
        {
          href: this.$router.resolve({ name: 'TermsAffiliate' }).href,
          title: this.$tc('common.termsAffiliateOfService'),
        },
        {
          href: 'https://tavenal.com/privacy/',
          title: this.$tc('common.privacyPolicy'),
        },
        {
          href: this.$router.resolve({ name: 'CommercialTransaction' }).href,
          title: this.$tc('footer.commercialTransaction'),
        },
      ],
    }
  },
  methods: {
    openUrl: (href: string) => window.open(href),
  },
})
